import { endPoint } from './base.config';

const prefix = `${endPoint}v2/supplier-product-lines`;

export const supplierProductLine = {
  getIntegrationSystems: `${prefix}/integration-systems`,
  getSuppliers: `${prefix}/suppliers`,
  getProductLines: prefix,
  updateProductLineStatus: `${prefix}/:id/status`,
  getProductLineMappings: `${prefix}/:id/mappings`,
  upsertProductLineMapping: `${prefix}/:id/mappings/:systemCode`,
  getSupplierDefaultMappings: `${prefix}/suppliers/:supplierId/default-mappings`,
  upsertSupplierDefaultMapping: `${prefix}/suppliers/:supplierId/default-mappings/:systemCode`,
  bulkUpdateMappingStatus: `${prefix}/mappings/status`,
  getMappingHistory: `${prefix}/mappings/:type/:id/history`,
};
